import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { PAGE_URL, remove } from '@/api/system/mail-recipient';
import { createFormItem } from '@/component-create/utils/create-form-item';
import { createTableColumn, tableAddHeader, tableDeleteController, tableDeleteHeader, tableEditController, tableEditHeader } from '@/component-create/utils/create-table-column';
import { useCommonDialog } from '@/component-create/utils/hooks';
import { FORM_ITEM } from '@/components/form/enums';
import { isOnlyOne } from '@/utils/common';
import { deleteBox, toast } from '@/utils/message';
import { renderContactAddForm } from './contact-add';
import { renderContactEditForm } from './contact-edit';

import { ref, onMounted } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Contact',
  setup(__props, {
    expose: __expose
  }) {
    const searchForm = ref();
    const tableRef = ref();
    const addFormRef = ref();
    const editFormRef = ref();
    let addForm;
    let editForm;
    let searchData = {};
    const dialog = useCommonDialog('contactDialog');
    onMounted(() => {
      addForm = renderContactAddForm(addFormRef.value);
      addForm.onSaveSuccess = () => {
        tableRef.value?.load(searchData);
      };
      editForm = renderContactEditForm(editFormRef.value);
      editForm.onSaveSuccess = () => {
        tableRef.value?.load(searchData);
      };
    });
    const items = [createFormItem('联系人名称', 'recipientName', FORM_ITEM.INPUT, {
      clearable: true,
      maxlength: '20'
    }), createFormItem('邮箱地址', 'mailAddress', FORM_ITEM.INPUT, {
      clearable: true,
      maxlength: '20'
    })];
    const column = [createTableColumn('联系人名称', 'recipientName'), createTableColumn('邮箱地址', 'mailAddress', '280', undefined, {
      showOverflowTooltip: true
    }), createTableColumn('备注', 'remark', undefined, undefined, {
      showOverflowTooltip: true
    }), createTableColumn('创建时间', 'createdAt', '150', 'center'), createTableColumn('操作', undefined, '200', 'center', {
      controller: [tableEditController(row => {
        editForm.open(row.id);
      }), tableDeleteController(row => {
        deleteBox().then(() => {
          remove([row.id]).then(() => {
            toast.success('删除成功');
            tableRef.value?.load(searchData);
          });
        });
      })]
    })];
    const headerButton = [tableAddHeader(() => {
      addForm.open();
    }), tableEditHeader(rows => {
      if (isOnlyOne(rows)) {
        editForm.open(rows[0].id);
      }
    }), tableDeleteHeader(rows => {
      if (rows.length === 0) {
        toast.warn('请至少选择一条数据');
      } else {
        deleteBox().then(() => {
          remove(rows.map(i => i.id)).then(() => {
            toast.success('删除成功');
            tableRef.value?.load(searchData);
          });
        });
      }
    })];
    function open() {
      dialog.open();
    }
    function reset() {
      searchData = {};
      tableRef.value?.load({});
    }
    function search(data) {
      searchData = data;
      tableRef.value?.load(data);
    }
    __expose({
      open
    });
    return (_ctx, _cache) => {
      const _component_XSearchForm = _resolveComponent("XSearchForm");
      const _component_XTable = _resolveComponent("XTable");
      const _component_XCommonDialog = _resolveComponent("XCommonDialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_XCommonDialog, {
        ref: "contactDialog",
        title: "联系人管理",
        width: "70%"
      }, {
        default: _withCtx(() => [_createVNode(_component_XSearchForm, {
          ref_key: "searchForm",
          ref: searchForm,
          items: items,
          onSearch: search,
          onReset: reset
        }, null, 512), _createVNode(_component_XTable, {
          ref_key: "tableRef",
          ref: tableRef,
          url: _unref(PAGE_URL),
          "show-index": "",
          selectable: "",
          column: column,
          "header-buttons": headerButton,
          "el-table-props": {
            border: true
          }
        }, null, 8, ["url"])]),
        _: 1
      }, 512), _createElementVNode("div", {
        ref_key: "addFormRef",
        ref: addFormRef
      }, null, 512), _createElementVNode("div", {
        ref_key: "editFormRef",
        ref: editFormRef
      }, null, 512)]);
    };
  }
});